// extracted by mini-css-extract-plugin
export default {"wrapper":"ArchivedProject_wrapper__uN4rU","user-progress-title":"ArchivedProject_user-progress-title__CAiIN"};